import * as React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { useConfig } from '@websky/core/src/context';
import { isMultiCity as getIsMultiCity } from '@websky/core/src/SearchForm/store/segments/selectors';
import Passengers from '@websky/core/src/SearchForm/components/SearchForm/Passengers/Passengers';
import StartSearch from '@websky/core/src/SearchForm/components/SearchForm/StartSearch/StartSearch';
import Currency from '@websky/core/src/SearchForm/components/SearchForm/Currency/Currency';
import css from './Controls.css';
const AdvancedPassengers = React.lazy(() => import('@websky/core/src/SearchForm/components/SearchForm/AdvancedPassengers/AdvancedPassengers'));
const Controls = React.memo(() => {
    const isMultiCity = useSelector(getIsMultiCity);
    const { SearchForm: { proMode, selectableCurrencies } } = useConfig();
    const withSelectableCurrencies = (selectableCurrencies === null || selectableCurrencies === void 0 ? void 0 : selectableCurrencies.length) > 1;
    return (React.createElement("div", { className: cn(css.controls, {
            [css.controls_multiCity]: isMultiCity,
            [css.controls_advanced]: proMode,
            [css.controls_withCurrency]: withSelectableCurrencies
        }) },
        React.createElement("div", { className: css.cell },
            proMode ? (React.createElement(React.Suspense, { fallback: "Loading..." },
                React.createElement(AdvancedPassengers, null))) : (React.createElement(Passengers, null)),
            withSelectableCurrencies && React.createElement(Currency, null)),
        React.createElement("div", { className: css.cell },
            React.createElement(StartSearch, { mode: "text" }))));
});
export default Controls;
